import axios from 'axios';

export class Api
{
	public static async Post (path: string, data: object)
	{
		try
		{
			const response = await axios.request({method: 'POST', url: path, data: data});
			if (response.status === 200)
			{
				return true;
			}

			console.error('API::Post >> Invalid Response', response);
		}
		catch (err)
		{
			console.error('API::Post >> Error', err);
		}

		return false;
	}
}